import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Theme } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${fonts.dmSans.regular};

  --bgColour: ${brand.grey.light};
  --borderColour: ${brand.grey.medium};
  --borderRadius: 12px;
  --placeholderColour: transparent;
  --readOnlyColour: ${brand.grey.dark};

  [data-theme=${Theme.Grey}] & {
    --bgColour: ${brand.global.white};
  }

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 1px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColour);
  height: 70px;
  font-size: 16px;
  margin: 0;
  padding: 24px;
  width: 100%;

  &:disabled {
    opacity: 0.85;
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &:read-only,
  &[readonly] {
    color: var(--readOnlyColour);
  }

  &::placeholder {
    color: var(--placeholderColour);
    opacity: 0.85;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const TextboxStyles = {
    Input,
};
export default TextboxStyles;
